import styled, { borderRadius, spacing } from "@rentiohq/web-theme";

// Below this width the text and the screenshot stack instead of sitting side
// by side.
const TWO_COLUMN_MIN_WIDTH = "1200px";

export const Intro = styled.p`
  margin: 0 0 ${spacing("loose")};
  font-size: 16px;
  line-height: 1.6;
  color: ${({ theme }) => theme.colors.neutral80};
`;

export const Section = styled.div<{ hasMedia: boolean }>`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${spacing("loose")};
  align-items: start;

  @media (min-width: ${TWO_COLUMN_MIN_WIDTH}) {
    grid-template-columns: ${({ hasMedia }) =>
      hasMedia ? "minmax(0, 2fr) minmax(0, 3fr)" : "minmax(0, 1fr)"};
  }
`;

// Scrolled to from a search result: clear of the dashboard's top bar, and
// outlined so the eye lands on it.
export const Anchor = styled.div<{ isTarget: boolean }>`
  margin-bottom: ${spacing("loose")};
  scroll-margin-top: calc(
    ${({ theme }) => theme.header.height}px + ${spacing("base")}
  );
  border-radius: ${borderRadius("large")};
  outline: ${({ isTarget, theme }) =>
    isTarget ? `2px solid ${theme.getColor("primary", "200")}` : "none"};
  outline-offset: 4px;
`;

export const Navigation = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${spacing("base")};
  margin-top: ${spacing("loose")};
`;
